<template>
    <div class="fillcontain">
        <div class="table_container">

            <el-table
                :data="tableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column
                label="打印点"
                prop="name">
              </el-table-column>

              <el-table-column
                label="小票状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.printerDataModel == null || scope.row.printerDataModel == ''" style="color: red">未配置</span>
                  <span v-else  style="color: green">已配置</span>
                </template>
              </el-table-column>
              <el-table-column
                label="打印机数量"
                :formatter="printerFormat">
              </el-table-column>
                <el-table-column label="操作" width="300">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row)">
                        配置小票
                    </el-button>
                    <el-button
                      size="mini"
                      @click="handlePrinterEdit(scope.row)">
                      配置打印机
                    </el-button>
                  </template>
                </el-table-column>
            </el-table>

            <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
                <el-form :model="printerNodeModel">

                    <el-form-item label="模板" label-width="80px">
                      <el-row>
                        <el-col :span="14"><el-input v-model="printerNodeModel.printData" type="textarea" rows="50" placeholder="订单号: ###b### ###order_no###  ###/b###
###br###
桌号: ###table_number###
###br###

菜品            单价            数量             总计
###br###
###start_goods_content###
###goods_name###            ###goods_sell_price###            ###goods_count###            ###goods_total_price###
###br###
###end_goods_content###

###br###
总金额：###total_price###
###br###
###cut###"></el-input></el-col>
                        <el-col :span="8" style="margin-left: 15px">
                          <p>替换内容</p>
                          <p>###order_no### : 订单号</p>
                          <p>###out_no### : 外部订单号</p>
                          <p>###order_get_number### : 取餐码</p>
                          <p>###goods_tag_name### : 规格</p>
                          <p>###total_price### : 订单总价</p>
                          <p>###real_price### : 订单支付价格</p>
                          <p>###table_number### : 餐桌编号</p>
                          <p>###note### : 订单备注</p>
                          <p>###goods_name### : 菜品名字</p>
                          <p>###goods_tag_name### : 菜品标签名</p>
                          <p>###goods_sell_price### : 菜品单价</p>
                          <p>###goods_count### : 菜品数量</p>
                          <p>###goods_count### : 菜品总价</p>
                          <p>###goods_count### : 菜品数量</p>
                          <p>###start_goods_content### : 菜品内容开始符</p>
                          <p>###end_goods_content### : 菜品内容结束符</p>
                          <p>###br### : 换行</p>
                          <p>###cut### : 切刀指令(主动切纸,仅限切刀打印机使用才有效果)</p>
                          <p>###cb###  ###/cb###: 居中放大</p>
                          <p>###b###  ###/b###: 放大一倍</p>
                          <p>###c###  ###/c###: 居中</p>
                          <p>###l###  ###/l###: 字体变高一倍</p>
                          <p>###w###  ###/w###: 字体变宽一倍</p>
                          <p>###right###  ###/right###: 右对齐</p>
                          <p>###bold###  ###/bold###: 加粗</p>
                          <p>###qr###  ###/qr###: 二维码</p>
                        </el-col>
                      </el-row>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>


          <el-dialog :title="dialog2.title" :visible.sync="dialog2.dialogFormVisible" :close-on-click-modal="dialog2.close">
            <div>
              <el-transfer
                :titles="choosePrintersTitles"
                :button-texts="['移除', '添加']"
                :format="{noChecked: '${total}',hasChecked: '${checked}/${total}'}"
                :right-default-checked="[60]"
                filterable
                :filter-method="filterMethod"
                filter-placeholder="请输入打印机名"
                v-model="choosePrinters"
                :data="allPrinters"
                @change="handlePrinterChange"
                :props="{
            key: 'id',
            label: 'name'
          }"
              >
              </el-transfer>
            </div>
          </el-dialog>
        </div>
    </div>
</template>

<script>

    export default {
        data(){
            return {
                loading:false,
                printerNodeModel:{
                    node_id:0,
                    printData:""
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"",
                    close:false,
                },
              tableData: [],

              dialog2:{
                dialogFormVisible:false,
                title:"打印机配置",
                close:false,
              },

              allPrinters: [],
              choosePrinters: [],
              choosePrintersTitles:['未选打印机',"已选打印机"],

              filterMethod(query, item) {
                return item.name.indexOf(query) > -1;
              }
            }
        },
        created(){
            var storage=window.localStorage;
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/printer_data_model', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.tableData = res.data.printerNodes;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            statusFormat(row,column){

              return (row.printerDataModel == null || row.printerDataModel == "")?"未配置":"已配置";
            },
            printerFormat(row,column){
              if(row.printers == null || row.printers == "" || row.printers.length == 0){
                  return "0台";
              }else{
                var hasUnUsed = 0;
                row.printers.forEach(function (value, i) {
                  if(value.status == 1){
                    hasUnUsed++;
                  }
                });

                if(hasUnUsed == 0) {
                  return row.printers.length + "台";
                }else{
                  return row.printers.length + "台("+hasUnUsed+"台未启用)";
                }
              }
            },
          handlePrinterEdit(row) {
              this.dialog.title = "给" + row.name+" 配置打印机";
              this.printerNodeModel.node_id = row.node_id;
              this.printersData(row.printers);
              this.dialog2.dialogFormVisible = true;

          },
            handleEdit(index, row) {
              // this.$router.push({path:'/store/printerDataModelEdit',query: {node_id: row.id}});
                  this.dialog.title = "配置:" + row.name;
                  if(row.printerDataModel != null && row.printerDataModel.printData != null) {
                    this.printerNodeModel.node_id = row.node_id;
                    this.printerNodeModel.printData = row.printerDataModel.printData;
                  }else{

                    this.printerNodeModel.node_id = row.node_id;
                    this.printerNodeModel.printData = '';
                  }
                  this.dialog.dialogFormVisible = true;
            },
            handleSave() {
                this.loading = true;
                var that = this;
                that.$api.put('/store/printer_data_model', that.printerNodeModel, response => {
                  if (response.status >= 200 && response.status < 300) {
                    console.log(response.data);
                    var res = response.data;
                    if (res.code == 0) {
                      this.$message({
                        message: that.dialog.title+'成功',
                        type: 'success'
                      });
                      this.dialog.dialogFormVisible = false;
                      this.initData();
                    }else{
                      this.$message({
                        message: res.msg,
                        type: 'warning'
                      });
                    }
                  } else {
                    this.$message({
                      message: "服务器维护中",
                      type: 'error'
                    });
                  }

                });

                this.loading = false;
            },

          printersData(hasChoosePrinters){
            var chooseIds = [];
            if(hasChoosePrinters != null) {
              hasChoosePrinters.forEach(function (value, i) {
                chooseIds.push(value.id);
              });
            }
            this.loading = true;
            var that = this;
            that.allPrinters = [];
            that.choosePrinters = [];
            that.$api.get('/store/printer', null, response => {
              if (response.status >= 200 && response.status < 300) {
                var res = response.data;
                if (res.code == 0) {
                  that.allPrinters = res.data.printers;
                  that.allPrinters.forEach(function(value,i){
                    if(that.in_array(value.id,chooseIds)){
                      console.log("+"+value.id);
                      that.choosePrinters.push(value.id);
                    }
                  });

                  console.log("+"+that.choosePrinters);
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
              }
              this.loading = false;
            });
          },
          handlePrinterSave() {
            var chooseIds = this.choosePrinters.join(',');
            var that = this;
            that.$api.put('/store/printer_data_model/'+this.printerNodeModel.node_id+"/printers", {printer_ids:chooseIds}, response => {
              if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var res = response.data;
                if (res.code == 0) {
                  console.log("打印机设置成功")
                  that.initData();
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
              }

            });

            this.loading = false;
          },
          in_array(search,array){
            for(var i in array){
              if(array[i]==search){
                return true;
              }
            }
            return false;
          },
          handlePrinterChange(value, direction, movedKeys){
            // movedKeys = movedKeys.join(',');
            this.handlePrinterSave();
          },


        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/PrinterDataModel.vue